




















































































import { IPaymentRequisition, IUser } from '@/models';
import Vue, { PropType } from 'vue';
import { mapActions } from 'vuex';
import PaymentRequisitionAPSpecialistPicker from './PaymentRequisitionAPSpecialistPicker.vue';

export default Vue.extend({
  name: 'RequisitionAPSpecialistListMenu',

  components: { PaymentRequisitionAPSpecialistPicker },

  props: {
    paymentRequisition: {
      type: Object as PropType<IPaymentRequisition>,
      required: true
    },
    disabled: Boolean
  },

  data() {
    return {
      apSpecialistLoading: false,
      apSpecialistDialog: false,
      errorMessage: '',
      // assign the current apSpecialist to paymentRequisition apSpecialist
      apSpecialist: null as null | number
    };
  },

  watch: {
    apSpecialistDialog(value: boolean) {
      if (value == true) {
        if (this.paymentRequisition.ap_specialist) {
          this.apSpecialist =
            (this.paymentRequisition.ap_specialist as IUser).id ??
            (this.paymentRequisition.ap_specialist as number);
        }
      }
    }
  },

  methods: {
    ...mapActions({
      assignRequisitionAPSpecialist:
        'paymentRequisition/assignRequisitionAPSpecialist'
    }),

    closeDialog() {
      this.errorMessage = '';
      this.apSpecialistLoading = false;
      this.apSpecialistDialog = false;
    },

    clearErrors() {
      this.errorMessage = '';
    },

    setRequisitionAPSpecialist(apSpecialist: number) {
      this.apSpecialistLoading = true;
      this.assignRequisitionAPSpecialist({
        paymentRequisitionId: this.paymentRequisition.id,
        apSpecialist
      })
        .then(() => {
          this.closeDialog();
        })
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.errorMessage = error.response.data.detail;
          } else {
            this.errorMessage = 'Error assigning Ap Specialist';
          }
        })
        .finally(() => {
          this.apSpecialistLoading = false;
        });
    }
  }
});
